import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assets/global.css';

import App from './App';
import './core/i18n';
import AuthService from './core/auth/AuthService';

import reportWebVitals from './reportWebVitals'; 

AuthService.initKeycloak(() =>
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root'),
  ),
);

reportWebVitals();
